import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Base from './base';

/**
 * `Service` The ForgeDM, is used to fetch data.
 */
var ForgeData = /*#__PURE__*/function (_Base) {
  /**
   * Create the ForgeData instance.
   *
   * @param sdk - the SDK instance
   */
  function ForgeData(sdk) {
    _classCallCheck(this, ForgeData);
    return _callSuper(this, ForgeData, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(ForgeData, _Base);
  return _createClass(ForgeData, [{
    key: "getItemByVersionUrn",
    value:
    /**
     * get item data by version urn
     * https://jira.autodesk.com/browse/FDX-536
     * https://aps.autodesk.com/en/docs/data/v2/reference/http/projects-project_id-versions-version_id-item-GET/
     */
    function getItemByVersionUrn(projectId, versionUrn) {
      var url = "/projects/b.".concat(projectId, "/versions/").concat(encodeURIComponent(versionUrn), "/item");
      return this.HttpService.dataV1.get(url);
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'ForgeData';
    }
  }]);
}(Base);
export default ForgeData;